import React from 'react';
import { useTranslation } from 'react-i18next';
import { QuickQuery } from '../types/energyData';
import { Sun, Zap, BarChart3, TrendingUp } from 'lucide-react';

interface QuickQueriesProps {
  onQuerySelect: (query: string) => void;
}

const QuickQueries: React.FC<QuickQueriesProps> = ({ onQuerySelect }) => {
  const { t } = useTranslation();
  const quickQueries: QuickQuery[] = [
    {
      id: 'pv_today',
      label: t('chat.pvProductionToday'),
      query: t('chat.pvProductionTodayQuery'),
      icon: 'sun'
    },
    {
      id: 'consumption_today',
      label: t('chat.consumptionToday'),
      query: t('chat.consumptionTodayQuery'),
      icon: 'zap'
    },
    {
      id: 'consumption_week',
      label: t('chat.consumptionWeek'),
      query: t('chat.consumptionWeekQuery'),
      icon: 'chart'
    },
    {
      id: 'tariffs_week',
      label: t('chat.tariffsWeek'),
      query: t('chat.tariffsWeekQuery'),
      icon: 'trending'
    }
  ];

  const getIcon = (iconName: string) => {
    switch (iconName) {
      case 'sun':
        return <Sun className="w-5 h-5 sm:w-5 sm:h-5" />;
      case 'zap':
        return <Zap className="w-5 h-5 sm:w-5 sm:h-5" />;
      case 'chart':
        return <BarChart3 className="w-5 h-5 sm:w-5 sm:h-5" />;
      case 'trending':
        return <TrendingUp className="w-5 h-5 sm:w-5 sm:h-5" />;
      default:
        return <BarChart3 className="w-5 h-5 sm:w-5 sm:h-5" />;
    }
  };

  return (
    <div className="space-y-2">
      <h3 className="text-xs sm:text-sm font-medium text-gray-700 mb-2 sm:mb-3">{t('chat.quickQueries')}</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5 sm:gap-2">
        {quickQueries.map((query) => (
          <button
            key={query.id}
            onClick={() => onQuerySelect(query.query)}
            className="flex items-center gap-3 p-3.5 sm:p-3 min-h-[44px] bg-white border border-gray-200 rounded-lg hover:border-soleco-500 hover:bg-soleco-50 active:bg-soleco-100 transition-all duration-200 text-left group touch-manipulation"
            aria-label={query.label}
          >
            <div className="text-soleco-600 group-hover:text-soleco-700 flex-shrink-0">
              {getIcon(query.icon)}
            </div>
            <span className="text-xs sm:text-sm font-medium text-gray-700 group-hover:text-soleco-700">
              {query.label}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuickQueries;
